import Joi from 'joi'

const TariffIconDialogValidation = Joi.object({
  name: Joi.string().empty(''),
  vehicleCapacity: Joi.string().empty(''),
})

export { TariffIconDialogValidation }
